module.exports = new __parcel__URL__("plane_1_blue.4bf9d835.png").toString();